module.exports = __webpack_public_path__ + "img/btn01.4f23f514.png";